import connector from '@/utils/Connection'

export default {
  actions: {
    async getPracticeList ({dispatch, commit},) {
      const result = await connector.getPracticeList();
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.practiceList = result.data;
      }
      return result;
    }
  }
}